/**
 * A token handed to a local preview run so the screens behind a session can be
 * opened without a Supabase project. It exists because those nine screens are
 * the product, and reviewing them should not require a mailbox.
 *
 * `import.meta.env.DEV` is the gate, and it is compile-time: Vite replaces it
 * with `false` in `vite build`, so the branch below is removed from the bundle
 * entirely. A production build cannot honour this variable even if someone sets
 * it.
 */
export function previewToken(): string | null {
  if (!import.meta.env.DEV) {
    return null;
  }
  return import.meta.env.VITE_PREVIEW_TOKEN || null;
}
